module.exports = __webpack_public_path__ + "img/logo.da5ca6a5.png";